module.exports = __webpack_public_path__ + "static/img/empty2.6b3d404a.png";